export default __webpack_public_path__ + "static/media/ams-aci-dark.ed10e9d6.svg";